const urlJoin = require('url-join');
const config = require('../config');
const { default: stipulate, buildOptions } = require('stipulate');
const { baseOptions } = require('./configuration');

const changeEmail = (data) => {
  const { baseUrl } = config.get();
  const { email } = data;

  const url = urlJoin(baseUrl, '/pb/users/me/change-email/');
  const requestOptions = buildOptions(baseOptions, {
    method: 'POST',
    body: JSON.stringify({ email }),
  });

  return stipulate(url, requestOptions);
};

module.exports = changeEmail;
